<template>
<v-container>
  <v-row>
    <v-col cols="12" md="2">
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
        ></v-text-field>
      </v-card-title>
    </v-col>
  </v-row>
  <v-data-table
      :headers="tableHeaders"
      :items="bannedSubs"
      class="elevation-1"
      :search="search"
  >
    <template v-slot:item.banned_at="{ item }">
      {{ item.banned_at | formatTimestamp}}
    </template>
    <template v-slot:item.last_checked="{ item }">
      {{ item.last_checked | formatTimestamp}}
    </template>
  </v-data-table>
</v-container>
</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import moment from "moment";
const StatsRepo = RepositoryFactory.get('stats')
export default {
  name: "BannedSubreddits",
  data: () => ({
    bannedSubs: [],
    search: '',
    tableHeaders: [
      {text: 'Subreddit', value: 'subreddit'},
      {text: 'Banned At', value: 'banned_at'},
      {text: 'Last Checked', value: 'last_checked'},
    ]
  }),
  methods: {
    loadBannedSubs() {
      StatsRepo.getBannedSubs({})
        .then(res => {
          if (res.status === 'error') {
            this.$emit('on-alert', {color: 'error', message: res.data})
            this.isLoading = false;
            return;
          }
          this.bannedSubs = res.data;
        })
    }
  },
  mounted() {
    this.loadBannedSubs();
  },
  filters: {
    formatTimestamp(timestamp) {
      return moment.unix(timestamp).format('YY-MM-DD h:mm:ss a')
    },
  }
}
</script>

<style scoped>

</style>